module.exports = __webpack_public_path__ + "img/DiNapoli-2.8365c70a.png";